import { Component, OnInit, Input, ViewChild, TemplateRef } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { ToasterService } from 'angular2-toaster';
import { ClientModel } from '../../../model';
import { ClientService } from '../../../services/client.service';
import { clientHistoryComponent } from '../../common/clientHistory';

@Component({
    selector: 'client-tab',
    templateUrl: './clientConversion.component.html',
})
export class ClientConversionComponent implements OnInit {

    isLoadMask: Promise<any>;
    clientIdOrPhone: string;
    clientDataList: any;
    clientData: ClientModel[];
    isLoading: boolean = false;
    isBtnVisible: boolean = false;
    loadingIndicator: boolean;
    bsModalRef: BsModalRef;
    buttonText = 'Combine';
    @Input() active = false;

    constructor(private clientService: ClientService, public toasterService: ToasterService, private modalService: BsModalService, ) {
        this.clientDataList = [];
        this.loadingIndicator = false;
    }


    ngOnInit(): void {
    }

    checkCheckBoxvalue(event, data) {
        for (var i = 0; i < this.clientDataList.length; i++) {
            if (this.clientDataList[i].client_id == data.client_id && event.target.id == 'customer') {
                this.clientDataList[i].cusCheck = true;
            }
            else if (event.target.id == 'customer') {
                this.clientDataList[i].cusCheck = false;
            }
            if (this.clientDataList[i].client_id == data.client_id && event.target.id == 'mobile') {
                this.clientDataList[i].mob = true;
            }
            else if (this.clientDataList[i].client_id == data.client_id && event.target.id == 'alt_mobile') {
                this.clientDataList[i].altMob = true;
            }
            else if (this.clientDataList[i].client_id != data.client_id && event.target.id == 'mobile') {
                this.clientDataList[i].mob = false;
            }
            else if (this.clientDataList[i].client_id != data.client_id && event.target.id == 'alt_mobile') {
                this.clientDataList[i].altMob = false;
            }

        }

    }


    getClientConversionList(): void {
        if (this.clientIdOrPhone == '' || this.clientIdOrPhone == undefined) {
            let toast = {
                type: 'error',
                title: 'ERROR',
                body: 'Enter Client ID or Mobile No'
            };
            this.toasterService.pop(toast);
            return;
        }
        else {
            if (this.clientDataList && this.clientDataList.length > 0) {
                for (var i = 0; i < this.clientDataList.length; i++) {
                    if (this.clientIdOrPhone == this.clientDataList[i].mobile || this.clientIdOrPhone == this.clientDataList[i].alt_mobile || this.clientIdOrPhone == this.clientDataList[i].client_no) {
                        this.clientIdOrPhone = '';
                        let toast = {
                            type: 'error',
                            title: 'ERROR',
                            body: 'Details Already Exists'
                        };
                        this.toasterService.pop(toast);
                        return;
                    }
                }
            }

            this.isBtnVisible = true;
            let params = {
                clientIdOrPhone: `${this.clientIdOrPhone}`
            };
            let that = this;
            this.isLoadMask = this.clientService
                .getClientConversionList(params)
                .then(function (res: any) {
                    that.clientIdOrPhone = '';
                    that.isBtnVisible = false;
                    if (res.success == 'success') {
                        res.data.cusCheck = false;
                        res.data.altMob = false;
                        res.data.mob = false;
                        that.clientDataList.push(res.data);
                    }
                    else {
                        let toast = {
                            type: 'error',
                            title: 'ERROR',
                            body: 'Details not avaiable'
                        };
                        that.toasterService.pop(toast);
                    }
                });
        }

    }

    //PREVIEW
    getClientHistoryCon() {
        let data = [];
        let clientIds = [];
        // let params = { data: null };
        // let a = '';

        if (this.clientDataList.length < 0) {
            return;
        }
        this.clientDataList.forEach(element => {
            data.push({ client_id: element.client_id, client_no: element.client_no, cusCheck: element.cusCheck,from_page:'followUp'});
            clientIds.push(element.client_id);
        });
        // data.forEach((x) => { a += x.client_id + ',' });
        // a = a.substring(0, a.length - 1);
        // params.data = a;

        

        let that = this;

        this.clientService
            .getClientConversionHistory({data: clientIds.toString()})
            .then(function (res: any) {
                if(res.success) {
                    that.bsModalRef = that.modalService.show(clientHistoryComponent, {
                        keyboard: false,
                        class: 'modal-lg maxWidthPer-80 clienthistorywidth'
                    });
                    that.bsModalRef.content.showClientHistory = res.convHistoryDetails.data;
                    let data = {
                        client_id: clientIds.toString(),
                        from_page: 'followUp'
                    }
                    that.bsModalRef.content.showClientHistory = data;
                    console.log("bsModel==== Data",data );
                } else {
                    const toast = {
                        type: 'error',
                        title: 'ERROR',
                        body: res.message
                    };
                    that.toasterService.pop(toast);
                }
            });

    }

    combineData() {
        let params = { client_id: null, mobile: null, alt_mobile: null, data: null }
        this.clientDataList.forEach((data) => {
            if (data.cusCheck == true) {
                params.client_id = data.client_id;
            }
            if (data.altMob == true) {
                params.alt_mobile = data.alt_mobile;
            }
            if (data.mob == true) {
                params.mobile = data.mobile
            }
        });

        if (params.client_id == null) {
            let toast = {
                type: 'error',
                title: 'ERROR',
                body: 'Please Select Client ID'
            };
            this.toasterService.pop(toast);
            return;
        }
        else if (params.mobile == null) {
            let toast = {
                type: 'error',
                title: 'ERROR',
                body: 'Please Select Mobile Number'
            };
            this.toasterService.pop(toast);
            return;
        }
        this.loadingIndicator = true;
        params.data = this.clientDataList;
        let that = this;
        this.isLoadMask = this.clientService
            .combineClientData(params)
            .then(function (res: any) {
                that.loadingIndicator = false;
                let toast = {
                    type: 'error',
                    title: 'ERROR',
                    body: res.message
                };
                if (res.success) {
                    that.clientDataList = [];
                    toast = {
                        type: 'success',
                        title: 'SUCCESS',
                        body: 'Data Successfully Combined'
                    };
                }
                that.toasterService.pop(toast);
            });
    }

}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/transaction/clientConversion/clientConversion.component.ts